(function () {
  var tooltip = null;
  var activeTarget = null;

  function getTooltip() {
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.className = 'card-title-tooltip';
      tooltip.setAttribute('role', 'tooltip');
      document.body.appendChild(tooltip);
    }
    return tooltip;
  }

  function show(target) {
    var text = target.getAttribute('data-tooltip');
    if (!text) return;

    activeTarget = target;
    var el = getTooltip();
    el.textContent = text;
    el.classList.remove('card-title-tooltip--visible', 'card-title-tooltip--above');

    var rect = target.getBoundingClientRect();
    var elRect = el.getBoundingClientRect();
    var spaceAbove = rect.top;
    var showAbove = spaceAbove > elRect.height + 16;

    var left = Math.max(8, Math.min(rect.left, window.innerWidth - elRect.width - 8));
    var top = showAbove ? rect.top - elRect.height - 10 : rect.bottom + 10;

    el.style.left = left + 'px';
    el.style.top = top + 'px';
    if (!showAbove) el.classList.add('card-title-tooltip--above');

    // Force layout before adding the visible class so the transition runs.
    // eslint-disable-next-line no-unused-expressions
    el.offsetHeight;
    el.classList.add('card-title-tooltip--visible');
  }

  function hide(target) {
    if (activeTarget !== target || !tooltip) return;
    tooltip.classList.remove('card-title-tooltip--visible');
    activeTarget = null;
  }

  function hideOnScroll() {
    if (tooltip) tooltip.classList.remove('card-title-tooltip--visible');
    activeTarget = null;
  }

  document.addEventListener(
    'mouseenter',
    function (event) {
      var target = event.target.closest && event.target.closest('[data-tooltip]');
      if (target) show(target);
    },
    true
  );

  document.addEventListener(
    'mouseleave',
    function (event) {
      var target = event.target.closest && event.target.closest('[data-tooltip]');
      if (target) hide(target);
    },
    true
  );

  document.addEventListener(
    'focus',
    function (event) {
      var target = event.target.closest && event.target.closest('[data-tooltip]');
      if (target) show(target);
    },
    true
  );

  document.addEventListener(
    'blur',
    function (event) {
      var target = event.target.closest && event.target.closest('[data-tooltip]');
      if (target) hide(target);
    },
    true
  );

  window.addEventListener('scroll', hideOnScroll, true);
  window.addEventListener('resize', hideOnScroll);
})();
